
export const getImageBackgroundGenerationViewStyles = () => ({
  imageBackgroundGenerationView: {
    display: 'flex',
    flexDirection: 'row',
    gap: '36px',

    '& .background-change-view-left-panel': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',

      '& .prompt-and-hisotry-container': {
        width: 400,
        '& .prompt-editor-container': {
          display: 'flex',
          flexDirection: 'column',

          '& .prompt-editor-label': {
            color: '#242424',
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 'normal',
            marginBottom: 8,
          },
        },
      },

      '& .spinner-container': {
        marginTop: 24,
      },

      '& .error-message': {
        marginTop: 16,
      },

      '& .background-change-view-actions-container': {
        '& .apply-generated-image-button': {
          padding: '5px 12px',
          marginRight: 8,
          borderRadius: 4,
        },

        '& .cancel-button': {
          padding: '5px 12px',
          borderRadius: 4,
        },
      },
      '& .generating-spinner-container': {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 24,
        '& .generating-spinner': {
          width: 20,
          height: 20,
          overflow: 'hidden',
        },
        '& span.generating-message': {
          flex: '1 0 0',
          color: '#605E5C',
          fontSize: 16,
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '22px',
          marginLeft: 8,
        },
      },
    },

    '& .example-image-list-container': {
      display: 'flex',
      flexDirection: 'column',

      '& .example-image-list-label': {
        color: '#605E5C',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 'normal',
        marginBottom: 8,
      },

      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
  },
  generatedImagePreviewContainer: {
    display: 'flex',
    width: 448,
    height: 421,
    borderRadius: 6,
    overflow: 'hidden',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      backgroundImage: 'linear-gradient(45deg, #D7D9D8 25%, transparent 25%), linear-gradient(-45deg, #D7D9D8 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #D7D9D8 75%), linear-gradient(-45deg, transparent 75%, #D7D9D8 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0px 0px, 0px 10px, 10px -10px, -10px 0px',
    },
  },
  generatingImageBackgroundContainer: {
    display: 'flex',
    width: 448,
    height: 421,
    borderRadius: 6,
    overflow: 'hidden',
    position: 'relative',

    '& .generating-image-shimmer': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: 6,
      opacity: 0.4,
      backgroundColor: '#E6E6E6',
      backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #47CFFA 50%, #B47CF8 100%)',
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      zIndex: 1,
    },
  },
});
